module.exports = __webpack_public_path__ + "static/media/winLarge61_1.5cc42b30.png";